export function parseVolume(v){
    if (v == null) return NaN;
    if (typeof v === 'number') return v;
    let s = String(v).replace(/[^\d.,-]/g, '');
    if (!s) return NaN;
    if (s.includes(',') && s.includes('.')) {
        s = s.replace(/\./g, '').replace(',', '.');
    } else if (s.includes(',')) {
        s = s.replace(',', '.');
    } else {
        s = s.replace(/\./g, '');
    }
    return parseFloat(s);
}

export const normalizePercentualValue = (value) => {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) return NaN;

    return Math.abs(numericValue) <= 1 ? numericValue * 100 : numericValue;
};

export const fmtCurrency = (v) =>
  Number.isFinite(v) ? v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-';

export const fmtPct = (v, opt = { min: 2, max: 2 }) =>
  Number.isFinite(v)
    ? `${v.toLocaleString('pt-BR', { minimumFractionDigits: opt.min, maximumFractionDigits: opt.max })}%`
    : '-';

export const fmtTons = (v) => (Number.isFinite(v) ? `${v.toLocaleString('pt-BR')} t` : '-');
export const fmtPts  = (v) => (Number.isFinite(v) ? `${v.toLocaleString('pt-BR')} pts` : '-');